import { InjectionToken } from '@angular/core';
import { Inject } from '@angular/core';
import { Injectable } from '@angular/core';
import { ofType } from '@ngrx/effects';
import { Actions } from '@ngrx/effects';
import { createEffect } from '@ngrx/effects';
import { toErrorMessage } from 'app/modules/main/helper/error-mapper';
import { UserFeatureFlagsFetcher } from 'app/modules/main/services/user-feature-flags-fetcher.service';
import { AdvertiserTimeZoneActions } from 'app/modules/main/store/advertiser-time-zone/advertiser-time-zone.actions';
import { UserAuthorizationSelectors } from 'app/modules/main/store/user-authorization/user-authorization.selectors';
import { LoadUserSettingsAction } from 'app/modules/main/store/user-settings/user-settings.actions';
import { UserSettingsActions } from 'app/modules/main/store/user-settings/user-settings.actions';
import { EMPTY } from 'rxjs';
import { of } from 'rxjs';
import { first } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';
import { exhaustMap } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserSettingsEffects {

  static readonly LOAD =
    new InjectionToken<LoadUserSettingsAction[]>('LOAD');

  constructor(
    private readonly actions: Actions,
    private readonly userAuthorizationSelectors: UserAuthorizationSelectors,
    private readonly userFeatureFlagsFetcher: UserFeatureFlagsFetcher,
    @Inject(UserSettingsEffects.LOAD)
    private readonly loadUserSettingsActions: LoadUserSettingsAction[] = [],
  ) {
  }

  readonly load = createEffect(
    () => this.actions.pipe(
      ofType(...this.loadUserSettingsActions.flat()),
      exhaustMap(() => this.fetchUserSettings()),
    )
  );

  private fetchUserSettings() {

    return this.userAuthorizationSelectors.getAuthorization()
      .pipe(
        first(),
        switchMap(authorization => this.userFeatureFlagsFetcher.fetch(authorization)),
        map(UserSettingsActions.userSettingsLoaded),
        catchError((error: any) =>
          error.status !== 0
            ? of(UserSettingsActions.userSettingsLoadFailed(toErrorMessage(error)))
            : EMPTY
        ),
      );
  }

}
